<template>
    <Wrapper class="info-tooltip">
        <a-tooltip placement="bottom" :trigger="trigger">
            <slot name="title" slot="title">
                <TOOLTIP_CONTENT v-html="label"></TOOLTIP_CONTENT>
            </slot>
            <FLEX_VERTICAL_CENTER_DIV class="icon-wrapper">
                <help-icon v-view-box />
            </FLEX_VERTICAL_CENTER_DIV>
        </a-tooltip>
    </Wrapper>
</template>

<script>
import styled from 'vue-styled-components';
import { applyHoverAndPress, square, COLORS } from '@styles/common.styled';

import {
    TOOLTIP_CONTENT,
    FLEX_VERTICAL_CENTER_DIV,
} from '@styles/common.styled.component';

import HelpIcon from '@svgIcons/help.svg';

const Wrapper = styled.span`
    display: inline-flex;
    cursor: pointer;
    svg {
        ${applyHoverAndPress(COLORS['gray-80'], 'fill')};
        ${square(20)};
        transition: fill 0.2s;
    }
`;

export default {
    name: 'InfoTooltip',
    components: {
        Wrapper,
        HelpIcon,
        TOOLTIP_CONTENT,
        FLEX_VERTICAL_CENTER_DIV,
    },
    props: {
        label: {
            type: String,
            default: '',
        },
        trigger: {
            type: Array,
            default() {
                return ['click', 'hover'];
            },
        },
    },
};
</script>
